// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    touch-action: manipulation; /* Отключает масштабирование при двойном клике */
    -webkit-user-select: none;
            user-select: none; /* Отключает выделение текста */
    background-color: #161616;
    font-family: 'Montserrat', sans-serif;
    color:white;
    /* font-weight: 200; */
  }

  button {
    font-family:'Montserrat', sans-serif;
  }`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;IACI,0BAA0B,EAAE,gDAAgD;IAC5E,yBAAiB;YAAjB,iBAAiB,EAAE,+BAA+B;IAClD,yBAAyB;IACzB,qCAAqC;IACrC,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;EACtC","sourcesContent":["@import './reset.css';\n\n\nhtml, body {\n    touch-action: manipulation; /* Отключает масштабирование при двойном клике */\n    user-select: none; /* Отключает выделение текста */\n    background-color: #161616;\n    font-family: 'Montserrat', sans-serif;\n    color:white;\n    /* font-weight: 200; */\n  }\n\n  button {\n    font-family:'Montserrat', sans-serif;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
